import{useRef as u}from"react";import{useSSR as c}from"use-ssr";const f=(s,t,r)=>{const e=u(!1),{isServer:o}=c();o&&s&&!e.current&&r&&(e.current=!0,r(t))};export{f as useOnLoadedSuccessForSsr};
